import SvgShape from '../plugins/svgShapePlugin';

export default function initSvgShape() {
  document.querySelectorAll('.offers-section').forEach((holder) => {
    const tableItems = holder.querySelectorAll('.offers-table tbody tr');

    tableItems.forEach((elem) => {
      let id = elem.dataset.flat;

      if (id) {
        const flat = holder.querySelector(`#${id}`);

        if (flat) {
          if (elem.dataset.status === 'disable') {
            flat.classList.add('disable');
          }

          flat.dataset.flat = id;
        }
      }
    });

    new SvgShape(holder, {
      svg: 'svg',
      table: '.offers-table',
      buildingHolder: '.plan-image-holder'
    });
  });
}